import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ResultTable from '../../components/ResultsPage/ResultTable';
import ResultLoadingPage from './ResultLoadingPage';
import axios from 'axios';

export default function ResultPage({ features }) {
    const [isLoading, setIsLoading] = useState(true);
    const [columns, setColumns] = useState(null);
    const [data, setData] = useState(null);
    const state = useLocation().state;
    const header = state ? state.version : "Error";
    const versionFeatures = state ? state.features : null;
    
    useEffect(() => {
        axios.post(`/api/versions/${header}`, {versionFeatures})
            .then(r => {
                setColumns(r.data.columns);
                setData(r.data.data);
                setIsLoading(false)
            })
    }, [header, versionFeatures])
    
    if (isLoading) {
        return <ResultLoadingPage />
    }

    if (!columns) {
        return <div>Error. No data found.</div>
    }

    return (
        <>
            <Link to={{
                pathname: '/version',
                state: {version: header}
            }}>
                <button className="text-gray-800 bg-white mt-3 ml-5 hover:text-purple-500 font-semibold py-2 px-4 border border-gray-400 rounded shadow">
                    Back
                </button>
            </Link>
            <div className="container py-6 px-4 text-white">
                <h1 className="text-3xl py-4 border-b mb-10">{header}</h1>
                <ResultTable columns={columns} data={data} features={features} />
            </div>
        </>
    )
}
